import React, {Suspense} from "react";
import {Redirect, Route, Switch, useLocation, withRouter} from "react-router-dom";
import Dashboard from "./Dashboard";
import {LayoutSplashScreen} from "../../../_metronic";
import {useSelector} from 'react-redux';
import UpdatePassword from '../user/password/Password';
import Profile from '../user/profile/Profile';
import GrowersList from "../grower";
import BuyersList from '../buyer';
import UserList from '../users';
import './index.scss';
import FlowerOrders from "../orders/flower/buyer";
import './overrides.scss';
import FlowerBuyerReport from "../reports/flowers/buyer";
import FlowerGrowerReport from "../reports/flowers/grower";
import TemperatureGrowerReport from "../reports/temperature/index";
import ShipmentReportReport from "../reports/shipment/index";
import FlowerInspectionReport from "../reports/flowers/inspection";
import GrowerFlowerOrders from "../orders/flower/grower";
import FlowerInspectionCriteriaReportList from "../orders/criteria/index";
import GrowerTemperatureReportList from "../orders/temperature/index";
import ShipmentReportList from "../orders/shipment/index";
import FlowerInspectionReportList from "../orders/inspection/index";
import BuyerPlantOrders from "../orders/plant/buyer";
import GrowerPlantOrders from "../orders/plant/grower";
import BuyerParentList from "../buyerParent";
import GrowerParentList from "../growerParent";
import PlantBuyerReport from "../reports/plants/buyer";
import PlantGrowerReport from "../reports/plants/grower";
import Settings from "./Settings";
import {translations} from '../settings/translations/list';
import Translation from "../settings/translations";
import FreightForwarderList from "../freightForwarder";
import DeliveryLocationList from "../deliveryLocation";
import LanguagesList from "../language";
import FlowerList from "../flower";
import ShipmentReport from "../reports/shipment";


function HomePage(props) {
    const user = useSelector(store => store.auth.user);
    const location = useLocation();

    const routes = [
        {
            path: '/reports/plants/grower/view',
            component: PlantGrowerReport,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: '/reports/plants/buyer/view',
            component: PlantBuyerReport,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },

        {
            path: '/reports/plants/grower',
            component: GrowerPlantOrders,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: '/freightForwarder',
            component: FreightForwarderList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: '/deliveryLocation',
            component: DeliveryLocationList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: '/language',
            component: LanguagesList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: '/reports/plants/buyer',
            component: BuyerPlantOrders,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']

        },
        {
            path: "/reports/flowers/grower",
            component: GrowerFlowerOrders,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "reports/plants/buyer",
            component: BuyerPlantOrders,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/reports/flowers/buyer/view",
            component: FlowerBuyerReport,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/reports/flowers/grower/view",
            component: FlowerGrowerReport,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/user/password",
            component: UpdatePassword,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/user/profile",
            component: Profile,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/reports/flowers/buyer",
            component: FlowerOrders,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: `/settings/flower`,
            component: FlowerList,
            exact: true,
            props: {moduleName: 'flower', isFlower: true},
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: `/settings/variety`,
            component: FlowerList,
            exact: true,
            props: {moduleName: 'variety', isFlower: false},
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: "/dashboard",
            component: Dashboard,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: "/settings",
            component: Settings,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: "/users",
            component: UserList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: "/growers",
            component: GrowersList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: "/buyers",
            component: BuyersList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: "/buyer/parents",
            component: BuyerParentList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: "/grower/parents",
            component: GrowerParentList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN']
        },
        {
            path: "/",
            component: Dashboard,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/dashboard",
            component: Dashboard,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/temperature",
            component: GrowerTemperatureReportList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/shipment",
            component: ShipmentReportList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/criteria",
            component: FlowerInspectionCriteriaReportList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: "/flower/inspection",
            component: FlowerInspectionReportList,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: '/reports/temperature/grower/view',
            component: TemperatureGrowerReport,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },

        {
            path: '/reports/flower/shipment/view',
            component: ShipmentReportReport,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },
        {
            path: '/reports/flower/inspection/view',
            component: FlowerInspectionReport,
            exact: true,
            roles: ['SUPER_ADMIN', 'ADMIN', 'INSPECTOR']
        },

    ];

    translations().forEach(moduleName => {
        routes.push({
            path: `/settings/${moduleName}`,
            component: Translation,
            exact: true,
            props: {moduleName},
            roles: ['SUPER_ADMIN', 'ADMIN']
        });
    });

    const validRoutes = routes.filter(route => route.roles.includes(user.role.name));

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    user.reset_password && location.pathname !== '/user/password' ?
                        <Redirect exact to="/user/password"/> : null
                }

                {validRoutes.map((route, key) => {
                    const Component = route.component;
                    return (
                        <Route path={route.path} component={() => {
                            return Component(Object.assign(route?.props ? route.props : {}, props));
                        }} key={key} exact={route.exact}/>
                    );

                })}

                <Redirect to="/"/>
            </Switch>
        </Suspense>

    );
}

export default withRouter(HomePage)


